import { diff } from 'jsondiffpatch';
import get from 'lodash/get';
import { css, cx } from 'emotion';
import React from 'react';

const containerStyle = css`
  padding: 0 15px;
  min-height: 70px;
  word-wrap: break-word;
  max-width: 300px;
`;

const nameStyle = css`
  margin: 3px 0;
`;

const disabled = css`
  color: #c4cdd6;
`;

const changed = css`
  font-weight: 600;
`;

const DiffInfoItem = ({ from, to, selector, name, render, renderText }) => {
  const termDiff = diff(from, to);
  const selectorDiff = get(termDiff, selector);

  let content;

  // if diff exists
  if (selectorDiff) {
    const newProps = { term: to, value: selectorDiff[1] };
    const oldProps = { term: from, value: selectorDiff[0] };
    if (render instanceof Function) {
      content = (
        <div>
          {render(newProps)}
          {render(oldProps)}
        </div>
      );
    } else {
      content = (
        <div>
          <div className={changed}>{renderText instanceof Function ? renderText(newProps) : selectorDiff[1]}</div>
          <div className={disabled}>{renderText instanceof Function ? renderText(oldProps) : selectorDiff[0]}</div>
        </div>
      );
    }
  }
  // the selected fields are same
  else {
    const value = get(from, selector);
    const props = { term: from, value };
    if (render instanceof Function) {
      content = render(props);
    } else {
      content = <div className={disabled}>{renderText instanceof Function ? renderText(props) : value}</div>;
    }
  }

  return (
    <div key={selector} className={cx(containerStyle)}>
      <h6 className={cx(nameStyle, !selectorDiff && disabled)}>{name ? name : selector}</h6>
      {content}
    </div>
  );
};

export default DiffInfoItem;
